import { ICreateNovosNegociosArquivoUseCase } from "../../../presentation/useCases/create/create_novos_negocios_arquivo_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * CreateNovosNegociosArquivoUseCase
 */

export class CreateNovosNegociosArquivoUseCase implements ICreateNovosNegociosArquivoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(
    idNovosNegocios?: number,
    arquivo?: File,
    descricao?: string,
  ): Promise<number> {

    const idNovosNegociosArquivo = await this.repository.createNovosNegociosArquivo(
      idNovosNegocios,
      arquivo ? arquivo.name : undefined,
      descricao,
      arquivo ? arquivo : undefined,
    );

    return idNovosNegociosArquivo;
  }
}
